import { Stack, Text, Flex, Icon, Button } from '@pairy/pds-react';
import Image from 'next/image';

import { logo } from '../../BulkLogos/index.constants';
import useCopy from '../useCopy';

import * as Styled from './index.styles';

const GmailBox = () => {
  const copy = useCopy();

  return (
    <Stack gap={8} direction="column">
      <Stack gap={4} direction="column">
        <Stack gap={2} alignItems="center">
          <Image
            src={logo.gmailWithText.src}
            alt={logo.gmailWithText.alt}
            width={logo.gmailWithText.width}
            height={logo.gmailWithText.height}
          />
          <Text variant="lg-semibold" color="zinc_500">
            로 여러 사람에게 자료를 보낼 땐
          </Text>
        </Stack>
        <Text variant="md-medium" color="zinc_400">
          &lsquo;첨부 파일&rsquo; 대신 메일 본문에 세일즈클루 링크를
          붙여넣으세요.
        </Text>
      </Stack>
      <Styled.Container gap={16} padding={16} direction="column">
        <Stack gap={8} direction="column">
          <Flex>
            <a
              target="_blank"
              href="https://docs.google.com/spreadsheets/d/1mEGwwD41n59Kr6jZ5cLMfV_txF4KZRYyCZJhtwTQpmQ/copy?usp=sharing"
              rel="noreferrer noopener nofollow"
            >
              <Flex as="button" alignItems="center" justifyContent="center">
                <Text variant="md-medium" as="p" paddingRight={4}>
                  1.
                </Text>
                <Icon icon="ph:file-text" size={17} color="skyblue_400" />
                <Text
                  as="p"
                  variant="md-medium"
                  color="skyblue_400"
                  marginLeft={4}
                >
                  스프레드 시트
                </Text>
              </Flex>
            </a>
            <Text as="p" variant="md-medium" marginLeft={4}>
              열어 ‘사본 만들기’ 클릭하기
            </Text>
          </Flex>
          <Flex>
            <Text variant="md-medium" as="p" paddingRight={4}>
              2.
            </Text>
            <Text as="p" variant="md-medium">
              시트 내 고객 정보 입력하기
            </Text>
          </Flex>
          <Flex>
            <Flex
              as="button"
              display="inline-flex"
              onClick={() => copy('gmail')}
            >
              <Text variant="md-medium" as="p" paddingRight={4}>
                3.
              </Text>
              <Icon icon="ph:link" size={17} color="skyblue_400" />
              <Text
                as="p"
                variant="md-medium"
                color="skyblue_400"
                marginLeft={4}
              >
                Gmail용 링크
              </Text>
            </Flex>
            <Text as="p" variant="md-medium" marginLeft={4}>
              메일 본문에 붙여넣기
            </Text>
          </Flex>
          <Flex>
            <Text variant="md-medium" as="p" paddingRight={4}>
              4.
            </Text>
            <Text as="p" variant="md-medium">
              스프레드 시트에서 &ldquo;Mail Merge&ldquo; 클릭해 전송하기
            </Text>
          </Flex>
        </Stack>

        <Button
          type="button"
          width="100%"
          variant="skyblue_300"
          textVariant="md-medium"
          radius={8}
          paddingX={16}
          paddingY={12}
          InnerWrappeGap={4}
          leftIcon={<Icon icon="ph:link" size={17} />}
          onClick={() => copy('gmail')}
        >
          Gmail용 링크 생성하기
        </Button>
        <Flex justifyContent="center">
          <a
            href="https://www.sclu.io/share/link/b80c0b87d965e3cd"
            target="_blank"
            rel="noreferrer noopener nofollow"
          >
            <Stack gap={8} justifyContent="center">
              <Text variant="md-medium" color="skyblue_400" marginRight={8}>
                자세한 가이드 보기
              </Text>
              <Icon icon="ph:caret-right" color="skyblue_400" size={17} />
            </Stack>
          </a>
        </Flex>
      </Styled.Container>
    </Stack>
  );
};

export default GmailBox;
